
export const getTimeoutTime = (percent) => {
	if (percent < 50) return 200
	if (percent < 75) return 700
	if (percent < 95) return 2000
	// go get some coffee, it won't move
	return 12000000
}
